import styled from 'styled-components';
import { fade, moveUp } from '../../shared/styles';

const STOP_WIDTH = '220px';
const STOP_WIDTH_MOBILE = '42vw';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding: 2rem 0;
`;

export const Rail = styled.ol`
	list-style: none;
	margin: 0;
	position: relative;
	width: 100%;
	display: flex;
	overflow-x: auto;
	scroll-snap-type: x mandatory;
	scrollbar-width: none;
	/* lets the first and last stop reach the center */
	padding-block: 0.5rem;
	padding-inline: calc(50% - ${STOP_WIDTH} / 2);
	box-sizing: border-box;
	/* fade jobs out toward the screen edges */
	mask-image: linear-gradient(to right, transparent, black 25%, black 75%, transparent);

	&::-webkit-scrollbar {
		display: none;
	}

	@media (max-width: 768px) {
		padding-inline: calc(50% - ${STOP_WIDTH_MOBILE} / 2);
		mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
	}
`;

export const Stop = styled.li`
	flex: 0 0 ${STOP_WIDTH};
	scroll-snap-align: center;
	position: relative;
	padding-top: 1.5rem;
	opacity: 0;
	animation: 1s ease ${(props) => props.$order * 0.15}s normal forwards 1
		${fade};

	/* the line */
	&::before {
		content: '';
		position: absolute;
		top: 0.3rem;
		left: 0;
		right: 0;
		height: 1px;
		background: ${({ theme }) => theme.text.main};
		opacity: 0.3;
	}

	/* the dot */
	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: calc(50% - 0.3rem);
		width: 0.6rem;
		height: 0.6rem;
		border-radius: 50%;
		border: 1px solid ${({ theme }) => theme.text.main};
		background: ${({ $active, theme }) =>
			$active ? theme.text.main : theme.main};
		transform: scale(${({ $active }) => ($active ? 1.4 : 1)});
		transition: background 0.4s ease, transform 0.4s ease;
	}

	> button {
		opacity: ${({ $active }) => ($active ? 1 : 0.4)};
		transition: opacity 0.4s ease;
	}

	@media (max-width: 768px) {
		flex-basis: ${STOP_WIDTH_MOBILE};
	}

	@media (prefers-reduced-motion: reduce) {
		animation: none;
		opacity: 1;
	}
`;

export const StopButton = styled.button`
	all: unset;
	box-sizing: border-box;
	display: block;
	width: 100%;
	padding: 0 0.5rem;
	text-align: center;
	cursor: pointer;

	&:focus-visible {
		outline: 1px dashed ${({ theme }) => theme.text.main};
		outline-offset: 4px;
	}
`;

export const Panel = styled.section`
	width: min(480px, 85vw);
	/* fixed height so the timeline below doesn't jump between jobs */
	min-height: 9rem;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	margin-bottom: 4.5rem;
	text-align: center;
	animation: 0.5s ease 0s normal forwards 1 ${fade},
		0.5s ease 0s normal forwards 1 ${moveUp};

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`;

export const Position = styled.h1`
	color: ${({ theme }) => theme.text.main};
	margin: 0;
	font-size: 1.5rem;
	text-transform: uppercase;

	@media (max-width: 768px) {
		font-size: 1.2rem;
	}
`;

export const Company = styled.span`
	display: block;
	color: ${({ theme }) => theme.text.main};
	font-weight: bold;
	text-transform: uppercase;
`;

export const Detail = styled.span`
	display: block;
	color: ${({ theme }) => theme.text.main};
	font-size: ${(props) => (props.size ? `0.75rem` : `1rem`)};
	font-weight: bold;
	text-transform: uppercase;

	@media (max-width: 768px) {
		font-size: ${(props) => (props.size ? `0.65rem` : `0.8rem`)};
	}
`;

export const InfoWrapper = styled.div`
	margin-top: 0.5rem;
`;

export const SkillsWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 0 12px;
	margin-top: 0.75rem;
`;

export const Resume = styled.a`
	font-size: 1rem;
	text-decoration: none;
	color: ${({ theme }) => theme.text.main};
	text-transform: uppercase;

	&:hover {
		color: ${({ theme }) => theme.text.hover};
	}
`;

export const ResumeWrapper = styled.div`
	margin-top: 2.5rem;
	animation: 2s ease 0s normal forwards 1 ${fade};
`;
